// inv/src/components/CookieConsent.jsx
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { applyGoogleConsent, getStoredCookieConsent, saveCookieConsent } from '../service-scripts/googleConsent';

const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    const cookieConsent = getStoredCookieConsent();
    if (cookieConsent) {
      applyGoogleConsent(cookieConsent);
    }

    if (!cookieConsent) {
      const timer = setTimeout(() => {
        setShowBanner(true);
        setTimeout(() => {
          setFadeIn(true);
        }, 10);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, []);

  const acceptCookies = () => {
    saveCookieConsent('accepted');
    setFadeIn(false);
    setTimeout(() => {
      setShowBanner(false);
    }, 300);
  };

  const rejectCookies = () => {
    saveCookieConsent('rejected');
    setFadeIn(false);
    setTimeout(() => {
      setShowBanner(false);
    }, 300);
  };

  if (!showBanner) return null;

  const languagePrefix = i18n.language === 'en' ? '' : `/${i18n.language}`;

  return (
    <div
      className={`fixed bottom-4 right-4 bg-white p-6 border shadow-lg max-w-lg rounded-lg transition-opacity duration-300 ${fadeIn ? 'opacity-100' : 'opacity-0'} z-50`}
    >
      <div className="flex flex-col space-y-4">
        <p className="text-sm m-0">
          {t('cookieConsent.message')}{' '}
          <a href={`${languagePrefix}/cookie-policy`} className="text-blue-500 underline">
            {t('cookieConsent.policyLink')}
          </a>.
        </p>
        <div className="flex space-x-4">
          <button
            onClick={acceptCookies}
            className="btn btn-outline btn-sm bg-black text-white px-4 py-2 rounded-md"
          >
            {t('cookieConsent.acceptAll')}
          </button>
          <button
            onClick={rejectCookies}
            className="btn btn-sm bg-stone-200 px-4 py-2 rounded-md hover:bg-stone-300 transition"
          >
            {t('cookieConsent.rejectAll')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
